import React from 'react';
import { motion } from 'framer-motion';
import { BarChart3, TrendingUp } from 'lucide-react';
import { useLang } from '../context/LanguageContext';
import Accordion from './Accordion';

export default function ExpandedFinancialScenario() {
  const { t } = useLang();
  const content = t.expandedScenario;

  return (
    <section className="relative py-20 md:py-28 px-6 overflow-hidden">
      <div className="max-w-5xl mx-auto relative z-10">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-12"
        >
          <h2 className="text-4xl md:text-6xl font-black font-heading purple-text mb-4">
            {content.title}
          </h2>
          <p className="text-[#9CA3AF] text-lg md:text-xl">
            {content.subtitle}
          </p>
        </motion.div>

        {/* Main Metrics */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-10">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="glass rounded-2xl p-8 text-center"
          >
            <BarChart3 size={32} className="text-[#8B5CF6] mx-auto mb-4" />
            <p className="text-[#9CA3AF] text-sm uppercase tracking-wider mb-2">
              {content.investment.split(':')[0]}
            </p>
            <p className="text-4xl md:text-5xl font-black font-heading text-white">
              ~300 000 €
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="glass rounded-2xl p-8 text-center"
          >
            <TrendingUp size={32} className="text-[#22C55E] mx-auto mb-4" />
            <p className="text-[#9CA3AF] text-sm uppercase tracking-wider mb-2">
              {content.revenue.split(':')[0]}
            </p>
            <p className="text-4xl md:text-5xl font-black font-heading gold-text">
              ~13 000 €
            </p>
            <p className="text-[#9CA3AF] text-sm mt-1">/месяц | /mes</p>
          </motion.div>
        </div>

        {/* Details in Accordion */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.2 }}
        >
          <Accordion title={content.detailsTitle}>
            <div className="space-y-6">
              <ul className="space-y-3">
                {content.details.map((detail, i) => (
                  <li key={i} className="flex items-start gap-3">
                    <span className="text-[#8B5CF6] mt-1.5">•</span>
                    <span className="text-[#E5E7EB] text-base leading-relaxed">{detail}</span>
                  </li>
                ))}
              </ul>

              <div className="mt-6 p-5 rounded-xl"
                style={{
                  background: 'linear-gradient(135deg, rgba(34,197,94,0.1) 0%, rgba(34,197,94,0.03) 100%)',
                  border: '1px solid rgba(34,197,94,0.3)',
                }}
              >
                <p className="text-[#22C55E] font-bold text-lg">{content.payback}</p>
              </div>
            </div>
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
}
